export function getUrlParams(url: string) {
  const getParams = url
    .split('?')
    .filter((item) => !item.includes(document.location.hostname))
    .join('&')

  const urlParams = new URLSearchParams(getParams)
  const params = Object.fromEntries(urlParams.entries())
  return params
}
